(() => {
  "use strict";
  const CARD_SELECTOR = '[data-activity-code="app_notifications"]';
  const API = "/apps/broadway-club/club/extra-activities";
  const standalone = () => window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;

  const cardParts = () => {
    const card = document.querySelector(CARD_SELECTOR);
    if (!card) return {};
    const button = card.querySelector("button");
    let status = card.querySelector("[data-pwa-reward-status]");
    if (!status) {
      status = document.createElement("p");
      status.dataset.pwaRewardStatus = "true";
      status.setAttribute("aria-live", "polite");
      card.append(status);
    }
    return {card, button, status};
  };

  const render = activity => {
    const {card, button, status} = cardParts();
    if (!card || !button || !status) return;
    const evidence = activity?.evidence || {};
    if (activity?.status === "points_awarded") {
      button.disabled = true;
      button.textContent = "150 punti accreditati";
      status.textContent = "Completata: installazione e notifiche verificate.";
      card.dataset.pwaRewardState = "awarded";
      return;
    }
    if (evidence.eligible) {
      button.disabled = true;
      button.textContent = "Requisiti verificati";
      status.textContent = "Verifica completata. Accredito in elaborazione.";
      card.dataset.pwaRewardState = "verified";
      return;
    }
    button.disabled = false;
    button.textContent = standalone() ? "Attiva le notifiche" : "Installa e attiva";
    status.textContent = standalone()
      ? "Apri l’autorizzazione alle notifiche per completare la missione."
      : "Installa l’app, aprila e attiva le notifiche per ricevere 150 punti.";
    card.dataset.pwaRewardState = "available";
  };

  const load = async () => {
    const response = await fetch(API, {credentials: "same-origin", headers: {Accept: "application/json"}});
    if (!response.ok) return;
    const payload = await response.json();
    render((payload.activities || []).find(item => item.activity_code === "app_notifications"));
  };

  const act = async () => {
    const {button, status} = cardParts();
    if (!button || button.disabled) return;
    button.disabled = true;
    status.textContent = "Verifica in corso…";
    try {
      if (!standalone()) {
        const result = await window.BRPWAInstall?.();
        status.textContent = result?.status === "accepted"
          ? "Installazione avviata. Apri Broadway Red e attiva le notifiche."
          : "Usa il menu del browser e scegli Installa app, poi apri Broadway Red.";
      } else {
        const result = await window.BRPWAEnablePush?.("Broadway Red App");
        status.textContent = result?.status === "registered"
          ? "Notifiche registrate. Controllo del premio in corso."
          : "Notifiche non attivate. Controlla le autorizzazioni del dispositivo.";
        await load();
      }
    } catch (_error) {
      status.textContent = "Verifica non disponibile. Riprova tra poco.";
    } finally {
      if (button.textContent !== "150 punti accreditati") button.disabled = false;
    }
  };

  document.addEventListener("click", event => {
    const button = event.target.closest?.(`${CARD_SELECTOR} button`);
    if (!button) return;
    event.preventDefault();
    act();
  });
  window.addEventListener("brpwa:state", event => {
    if (["standalone_report", "push_registration", "push_revocation"].includes(event.detail?.name)) {
      load().catch(() => {});
    }
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => load().catch(() => {}));
  else load().catch(() => {});
})();
